import { AfterContentInit, Directive, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[init]',
  standalone: false
})
export class InitDirective implements AfterContentInit {
  @Output() init = new EventEmitter<void>();
  
  ngAfterContentInit() {
    this.init.emit();
  }
}